import type {ReactElement} from 'react';
import React from 'react';
import {CustomScaledDimensionsInfoBox} from '@Components/poster-editor/components/custom-item-controls/components/custom-scaled-dimensions-info-box/custom-scaled-dimensions-info-box';
import {CustomItemUnlockControl} from '@Components/poster-editor/components/custom-item-unlock-control/custom-item-unlock-control';
import {CustomRotationControl} from '@Components/poster-editor/components/custom-rotation-control/custom-rotation-control';
import {CustomItemControlTl} from '@Components/poster-editor/components/custom-item-control-tl/custom-item-control-tl';
import {CustomItemControlBl} from '@Components/poster-editor/components/custom-item-control-bl/custom-item-control-bl';
import {CustomItemControlTr} from '@Components/poster-editor/components/custom-item-control-tr/custom-item-control-tr';
import {CustomItemControlBr} from '@Components/poster-editor/components/custom-item-control-br/custom-item-control-br';
import type {CustomItemControlsWrapperProps} from '@Components/poster-editor/components/custom-item-controls/components/custom-item-controls-wrapper/custom-item-controls-wrapper.types';
import {useGetItemsFabricObjectPositionOrDimensionKeysMap} from '@Hooks/poster-editor/useGetItemsFabricObjectPositionOrDimensionKeysMap';
import {SelectionType} from '@Components/poster-editor/components/custom-item-controls/custom-item-controls.types';
import {useSingleActivePosterItem} from '@Hooks/poster-editor/useSingleActivePosterItem';

export function ActiveSelectionCustomControls(props: CustomItemControlsWrapperProps): ReactElement<any> | null {
  const multiSelectionPositionPropertiesMap = useGetItemsFabricObjectPositionOrDimensionKeysMap(props.pageHashedId, SelectionType.MULTI_SELECTION);
  const activeItemsPositionPropertiesMap = useGetItemsFabricObjectPositionOrDimensionKeysMap(props.pageHashedId);

  const activeItem = useSingleActivePosterItem(props.pageHashedId);

  let positionProperties = undefined;

  if (multiSelectionPositionPropertiesMap && Object.values(multiSelectionPositionPropertiesMap)[0] !== undefined) {
    positionProperties = Object.values(multiSelectionPositionPropertiesMap)[0];
  } else if (activeItemsPositionPropertiesMap && Object.values(activeItemsPositionPropertiesMap)[0] !== undefined) {
    positionProperties = Object.values(activeItemsPositionPropertiesMap)[0];
  }

  if (!positionProperties) {
    return null;
  }

  return (
    <>
      <CustomItemUnlockControl pageHashedId={props.pageHashedId} positionProperties={positionProperties} />
      <CustomRotationControl pageHashedId={props.pageHashedId} positionProperties={positionProperties} />
      {!activeItem?.isLine() ? (
        <>
          <CustomItemControlTl pageHashedId={props.pageHashedId} positionProperties={positionProperties} />
          <CustomItemControlBl pageHashedId={props.pageHashedId} positionProperties={positionProperties} />
          <CustomItemControlTr pageHashedId={props.pageHashedId} positionProperties={positionProperties} />
          <CustomItemControlBr pageHashedId={props.pageHashedId} positionProperties={positionProperties} />
        </>
      ) : null}
      <CustomScaledDimensionsInfoBox pageHashedId={props.pageHashedId} positionProperties={positionProperties} />
    </>
  );
}
